import { Injectable } from '@angular/core';
import { ApiBaseService } from '../api-base/api-base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TPollyVoice } from './TPollyVoice';
import { Level1Elements } from './Level1Elements';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  playersActiveRoutes = new BehaviorSubject(null);
  public get playersActiveRoutesValue(): IplayerRouteDetails {
    return this.playersActiveRoutes.value;
  }

  lazyPaths: IlazyPaths[] = [
    {
      name: 'music',
      path: 'music/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'voices',
      path: 'voices/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'image',
      path: 'backgrounds/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Background Image',
      path: 'backgrounds/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Supporting Image',
      path: 'backgrounds/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'character',
      path: 'characters/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Left Character',
      path: 'characters/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Right Character',
      path: 'characters/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },

    {
      name: 'Center(L) Character',
      path: 'characters/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },

    {
      name: 'Center Character',
      path: 'characters/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },

    {
      name: 'Center(R) Character',
      path: 'characters/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },

    {
      name: 'company',
      path: 'companies/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Sequence',
      path: 'sequences/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Intro Sequence',
      path: 'sequences/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Questions List',
      path: 'questions/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Branches List',
      path: 'branches/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Jumbles List',
      path: 'jumbles/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Orderings List',
      path: 'orderings/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Questions Game',
      path: 'questions-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'MTC List',
      path: 'match-column/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Jumbles Game',
      path: 'jumbles-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Cross Words Game',
      path: 'cross-words-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'MTC Game',
      path: 'match-column-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'SJT Game',
      path: 'sjt-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Learning Game',
      path: 'master-game/list?type=learning',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Orders Game',
      path: 'orderings-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'MatchColumn Game',
      path: 'match-column-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Classifications Game',
      path: 'classification-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Mini Game',
      path: 'mini-games/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Password Game',
      path: 'password-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Values Game',
      path: 'values-games/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Feedback Question Set',
      path: 'feedback/question-sets/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Videos',
      path: 'videos/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'Pdf',
      path: 'pdf/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'File',
      path: 'file',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'WheelSpinGame',
      path: 'wheel-spin-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'MarioGame',
      path: 'mario-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'PackingGame',
      path: 'packing-game/list',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
    {
      name: 'MonopolyTurnGame',
      path: 'monopoly-turn-game',
      data: new BehaviorSubject(null),
      isLoading: false,
    },

    {
      name: 'File',
      path: 'file',
      data: new BehaviorSubject(null),
      isLoading: false,
    },
  ];
  constructor(private _api: ApiBaseService) {}

  // To-clear-data on dataChange
  clearPathData(name): void {
    this.lazyPaths.find((o) => o.name === name).data.next(null);
  }

  // character endpoints
  uploadCharector(data): Observable<any> {
    return this._api.post('characters/image/upload', data, {
      // reportProgress: true,
      // observe: 'events'
    });
  }

  getcharacters(data): Observable<any> {
    return this._api.get('characters/list', data, {});
  }
  editcharacters(data): Observable<any> {
    return this._api.put('characters/edit', data, {});
  }
  deleteCharectorsImg(data): Observable<any> {
    return this._api.delete('characters/image', { body: data });
  }
  deleteCharectors(data): Observable<any> {
    return this._api.delete('characters', { body: data });
  }
  addCharacters(data): Observable<any> {
    return this._api.post('characters/add', data, {});
  }

  cloneLevel1Element(type: Level1Elements, data): Observable<any> {
    return this._api.post('general/element/clone/' + type, data, {});
  }

  // Images endpoints lvl1
  uploadImages(data): Observable<any> {
    return this._api.post('backgrounds/image/upload', data, {});
  }

  getImages(data): Observable<IListData> {
    return this._api.get('backgrounds/list', data, {});
  }
  editImages(data): Observable<any> {
    return this._api.put('backgrounds/edit', data, {});
  }
  deleteImagesImg(data): Observable<any> {
    return this._api.delete('backgrounds/image', { body: data });
  }
  deleteImage(data): Observable<any> {
    return this._api.delete('backgrounds', { body: data });
  }
  addImage(data): Observable<any> {
    return this._api.post('backgrounds/add', data, {});
  }

  // music endpoints

  uploadMusic(data): Observable<string> {
    return this._api.post('music/file/upload', data, { responseType: 'text' });
  }

  getMusic(data): Observable<IListData> {
    return this._api.get('music/list', data, {});
  }
  editMusic(data): Observable<any> {
    return this._api.put('music/edit', data, {});
  }
  deleteMusicfile(data): Observable<any> {
    return this._api.delete('music/file', { body: data });
  }
  deleteMusic(data): Observable<any> {
    return this._api.delete('music', { body: data });
  }
  addMusic(data): Observable<any> {
    return this._api.post('music/add', data, {});
  }

  // voice endpoints
  uploadVoices(data): Observable<any> {
    return this._api.post('voices/file/upload', data, { responseType: 'text' });
  }

  getVoices(data): Observable<any> {
    return this._api.get('voices/list', data, {});
  }

  editVoices(data): Observable<any> {
    return this._api.put('voices/edit', data, {});
  }

  deleteVoicefile(data): Observable<any> {
    return this._api.delete('voices/file', { body: data });
  }

  deleteVoices(data): Observable<any> {
    return this._api.delete('voices', { body: data });
  }

  addVoice(data): Observable<any> {
    return this._api.post('voices/add', data, {});
  }

  // Pdf endpoints

  uploadPdf(data): Observable<string> {
    return this._api.post('pdf/file/upload', data, { responseType: 'text' });
  }
  getPdf(data): Observable<IListData> {
    return this._api.get('pdf/list', data, {});
  }
  editPdf(data): Observable<any> {
    return this._api.put('pdf/edit', data, {});
  }
  deletePdfFile(data): Observable<any> {
    return this._api.delete('pdf/file', { body: data });
  }
  deletePdf(data): Observable<any> {
    return this._api.delete('pdf', { body: data });
  }
  addPdf(data): Observable<any> {
    return this._api.post('pdf/add', data, {});
  }

  // videos endpoints

  getVideo(data): Observable<IListData> {
    return this._api.get('videos/list', data, {});
  }
  editVideo(data): Observable<any> {
    return this._api.put('videos/edit', data, {});
  }
  deleteVideo(data): Observable<any> {
    return this._api.delete('videos', { body: data });
  }
  addVideo(data): Observable<any> {
    return this._api.post('videos/add', data, {});
  }

  // Companies
  getCompanies(data: IListParams): Observable<IListData> {
    return this._api.get('companies/list', data, {});
  }

  editCompany(data): Observable<any> {
    return this._api.put('companies/edit', data, {});
  }

  deleteCompany(data): Observable<any> {
    return this._api.delete('companies', { body: data });
  }

  addCompany(data): Observable<any> {
    return this._api.post('companies/add', data, {});
  }

  // Divisions
  getDivisions(data: IListParams): Observable<IListData> {
    return this._api.get('divisions/list', data, {});
  }

  editDivision(data): Observable<any> {
    return this._api.put('divisions/edit', data, {});
  }

  deleteDivision(data): Observable<any> {
    return this._api.delete('divisions', { body: data });
  }

  addDivision(data): Observable<any> {
    return this._api.post('divisions/add', data, {});
  }

  getDivisionsById(data): Observable<any> {
    return this._api.get('divisions/company/' + data, {}, {});
  }

  // Players
  getPlayers(data: IListParams): Observable<IListData> {
    return this._api.post('players/list', data, {});
  }
  getCompletedPlayers(data: IListParams, divisionId): Observable<IListData> {
    return this._api.get('players/gameStatus/' + divisionId, data, {});
  }

  getPlayerById(data: string): Observable<any> {
    return this._api.get(`players/${data}`, {}, {});
  }

  deletePlayer(data): Observable<any> {
    return this._api.delete('players', { body: data });
  }
  getPlayersFeedback(
    email,
  ): Observable<{ playerFeedback: any; questionsDetails: any }> {
    return this._api.get('feedback/surveys/getplayerfeedback/' + email, {}, {});
  }

  // sequence component
  addSequence(data): Observable<any> {
    return this._api.post('sequences/add', data, {});
  }
  getSequence(data): Observable<any> {
    return this._api.get('sequences/list', data, {});
  }
  getSequenceById(data): Observable<any> {
    return this._api.get('sequences/' + data, {}, {});
  }
  editSequence(data): Observable<any> {
    return this._api.put('sequences/edit', data, {});
  }
  deleteSequence(data): Observable<any> {
    return this._api.delete('sequences', { body: data });
  }
  // Jumbles
  addJumbles(data): Observable<any> {
    return this._api.post('jumbles/add', data, {});
  }
  getJumblesList(query): Observable<IListData> {
    return this._api.get('jumbles/list', query, {});
  }
  getJumblesById(data): Observable<any> {
    return this._api.get('jumbles/' + data, {}, {});
  }
  editJumbles(data): Observable<any> {
    return this._api.put('jumbles/edit', data, {});
  }
  deleteJumbles(data): Observable<any> {
    return this._api.delete('jumbles', { body: data });
  }

  // Questions

  getQuestionsList(query): Observable<IListData> {
    return this._api.get('questions/list', query, {});
  }
  addQuestion(data): Observable<any> {
    return this._api.post('questions/add', data, {});
  }
  getQuestionById(data): Observable<any> {
    return this._api.get('questions/' + data, {}, {});
  }
  editQuestion(data): Observable<any> {
    return this._api.put('questions/edit', data, {});
  }
  deleteQuestion(data): Observable<any> {
    return this._api.delete('questions', { body: data });
  }

  // branches

  getBranchesList(query): Observable<IListData> {
    return this._api.get('branches/list', query, {});
  }
  addBranches(data): Observable<any> {
    return this._api.post('branches/add', data, {});
  }
  getBranchesById(data): Observable<any> {
    return this._api.get('branches/' + data, {}, {});
  }
  editBranches(data): Observable<any> {
    return this._api.put('branches/edit', data, {});
  }
  deleteBranches(data): Observable<any> {
    return this._api.delete('branches', { body: data });
  }

  // Orderings

  getOrderList(query): Observable<IListData> {
    return this._api.get('orderings/list', query, {});
  }
  addOrder(data): Observable<any> {
    return this._api.post('orderings/add', data, {});
  }
  getOrderById(data): Observable<any> {
    return this._api.get('orderings/' + data, {}, {});
  }
  editOrder(data): Observable<any> {
    return this._api.put('orderings/edit', data, {});
  }
  deleteOrder(data): Observable<any> {
    return this._api.delete('orderings', { body: data });
  }
  // MTCGame

  getMTCGameList(query): Observable<IListData> {
    return this._api.get('match-column-game/list', query, {});
  }
  addMTCGame(data): Observable<any> {
    return this._api.post('match-column-game/add', data, {});
  }
  getMTCGameById(data): Observable<any> {
    return this._api.get('match-column-game/' + data, {}, {});
  }
  editMTCGame(data): Observable<any> {
    return this._api.put('match-column-game/edit', data, {});
  }
  deleteMTCGame(data): Observable<any> {
    return this._api.delete('match-column-game', { body: data });
  }

  // lvl3
  // questions game
  getQuestionsGameList(query): Observable<IListData> {
    return this._api.get('questions-game/list', query, {});
  }
  addQuestionsGame(data): Observable<any> {
    return this._api.post('questions-game/add', data, {});
  }
  getQuestionsGameById(data): Observable<any> {
    return this._api.get('questions-game/' + data, {}, {});
  }
  editQuestionsGame(data): Observable<any> {
    return this._api.put('questions-game/edit', data, {});
  }
  deleteQuestionsGame(data): Observable<any> {
    return this._api.delete('questions-game', { body: data });
  }

  // Jumbles-Game
  getJumblesGameList(query): Observable<IListData> {
    return this._api.get('jumbles-game/list', query, {});
  }
  addJumblesGame(data): Observable<any> {
    return this._api.post('jumbles-game/add', data, {});
  }
  getJumblesGameById(data): Observable<any> {
    return this._api.get('jumbles-game/' + data, {}, {});
  }
  editJumblesGame(data): Observable<any> {
    return this._api.put('jumbles-game/edit', data, {});
  }
  deleteJumblesGame(data): Observable<any> {
    return this._api.delete('jumbles-game', { body: data });
  }

  // Cross-Words-Game
  getCrossWordsGameList(query): Observable<IListData> {
    return this._api.get('cross-words-game/list', query, {});
  }
  addCrossWordsGame(data): Observable<any> {
    return this._api.post('cross-words-game', data, {});
  }
  getCrossWordsGameById(data): Observable<any> {
    return this._api.get('cross-words-game/' + data, {}, {});
  }
  editCrossWordsGame(data): Observable<any> {
    return this._api.put('cross-words-game', data, {});
  }
  deleteCrossWordsGame(data): Observable<any> {
    return this._api.delete('cross-words-game', { body: data });
  }

  // Words-Puzzle-Game
  getWordsPuzzleGameList(query): Observable<IListData> {
    return this._api.get('words-puzzle-game/list', query, {});
  }
  addWordsPuzzleGame(data): Observable<any> {
    return this._api.post('words-puzzle-game/add', data, {});
  }
  getWordsPuzzleGameById(data): Observable<any> {
    return this._api.get('words-puzzle-game/' + data, {}, {});
  }
  editWordsPuzzleGame(data): Observable<any> {
    return this._api.put('words-puzzle-game/edit', data, {});
  }
  deleteWordsPuzzleGame(data): Observable<any> {
    return this._api.delete('words-puzzle-game', { body: data });
  }


  // Ordering-Game
  getOrderingsGameList(query): Observable<IListData> {
    return this._api.get('orderings-game/list', query, {});
  }
  addOrderingsGame(data): Observable<any> {
    return this._api.post('orderings-game/add', data, {});
  }
  getOrderingsGameById(data): Observable<any> {
    return this._api.get('orderings-game/' + data, {}, {});
  }
  editOrderingsGame(data): Observable<any> {
    return this._api.put('orderings-game/edit', data, {});
  }
  deleteOrderingsGame(data): Observable<any> {
    return this._api.delete('orderings-game', { body: data });
  }

  // Classification-Game
  getClassificationsGameList(query): Observable<IListData> {
    return this._api.get('classification-game/list', query, {});
  }
  addClassificationsGame(data): Observable<any> {
    return this._api.post('classification-game/add', data, {});
  }
  getClassificationsGameById(data): Observable<any> {
    return this._api.get('classification-game/' + data, {}, {});
  }
  editClassificationsGame(data): Observable<any> {
    return this._api.put('classification-game/edit', data, {});
  }
  deleteClassificationsGame(data): Observable<any> {
    return this._api.delete('classification-game', { body: data });
  }

  // MTC-Game
  getMTCList(query): Observable<IListData> {
    return this._api.get('match-column/list', query, {});
  }
  addMTC(data): Observable<any> {
    return this._api.post('match-column/add', data, {});
  }
  getMTCById(data): Observable<any> {
    return this._api.get('match-column/' + data, {}, {});
  }
  editMTC(data): Observable<any> {
    return this._api.put('match-column/edit', data, {});
  }
  deleteMTC(data): Observable<any> {
    return this._api.delete('match-column', { body: data });
  }

  // SJT-Game
  getSJTGameList(query): Observable<IListData> {
    return this._api.get('sjt-game/list', query, {});
  }
  // wheel game
  getWheelGameList(query): Observable<IListData> {
    return this._api.get('wheel-spin-game/list', query, {});
  }

  addSJTGame(data): Observable<any> {
    return this._api.post('sjt-game/add', data, {});
  }
  // add Wheel game
  addWheelGame(data: any): Observable<any> {
    return this._api.post('wheel-spin-game/add', data, {});
  }

  // edit Wheel game
  editWheelGame(data): Observable<any> {
    return this._api.put('wheel-spin-game/edit', data, {});
  }

  // wheel game
  getWheelGameById(data): Observable<any> {
    return this._api.get('wheel-spin-game/' + data, {}, {});
  }

  // delete wheel game
  deleteWheelGame(data): Observable<any> {
    return this._api.delete('wheel-spin-game', { body: data });
  }

  getSJTGameById(data): Observable<any> {
    return this._api.get('sjt-game/' + data, {}, {});
  }
  editSJTGame(data): Observable<any> {
    return this._api.put('sjt-game/edit', data, {});
  }
  deleteSJTGame(data): Observable<any> {
    return this._api.delete('sjt-game', { body: data });
  }

  // Master-Game
  getMasterGameList(query): Observable<IListData> {
    return this._api.get('master-game/list', query, {});
  }
  getOrientationGameList(query): Observable<IListData> {
    const qp = { type: 'orientation', ...query };
    return this._api.get('master-game/list', qp, {});
  }
  getLearningGameList(query): Observable<IListData> {
    const qp = { type: 'learning', ...query };
    return this._api.get('master-game/list', qp, {});
  }

  getLearningPlayerLeaderboard(divisionId: string): Observable<any> {
    return this._api.get(`learning-players/division/${divisionId}`);
  }

  getAptitudeGames(): Observable<TAptitudeGameListResponse> {
    return this._api.get('aptitude/games/list', {}, {});
  }

  addAptitudeGame(data: { name: string; gameType: string }): Observable<any> {
    return this._api.post('aptitude/games/add', data, {});
  }

  editAptitudeGame(data): Observable<any> {
    return this._api.put('aptitude/games/edit', data, {});
  }

  deleteAptitudeGame(data): Observable<any> {
    return this._api.delete('aptitude/games', { body: data });
  }

  addMasterGame(data): Observable<any> {
    return this._api.post('master-game/add', data, {});
  }
  getMasterGameById(data): Observable<any> {
    return this._api.get('master-game/' + data, {}, {});
  }
  editMasterGame(data): Observable<any> {
    return this._api.put('master-game/edit', data, {});
  }
  deleteMasterGame(data): Observable<any> {
    return this._api.delete('master-game', { body: data });
  }
  // Master-Game-Order
  getMasterGameOrderList(query): Observable<IListData> {
    return this._api.get('mg-order/list', query, {});
  }
  addMasterGameOrder(data): Observable<any> {
    return this._api.post('mg-order/add', data, {});
  }
  getMasterGameOrderById(data): Observable<any> {
    return this._api.get('mg-order/' + data, {}, {});
  }
  editMasterGameOrder(data): Observable<any> {
    return this._api.put('mg-order/edit', data, {});
  }
  deleteMasterGameOrder(data): Observable<any> {
    return this._api.delete('mg-order', { body: data });
  }
  // comman
  getWithUrl(url, data): Observable<any> {
    return this._api.get(url, data, {});
  }

  // Users
  getUsers(data: IListParams): Observable<IListData> {
    return this._api.get('users/list', data, {});
  }

  editUser(data): Observable<any> {
    return this._api.put('users/edit', data, {});
  }

  deleteUser(data): Observable<any> {
    return this._api.delete('users', { body: data });
  }

  addUser(data): Observable<any> {
    return this._api.post('users/add', data, {});
  }

  // User Management
  changePassword(data): Observable<any> {
    return this._api.post('users/changepassword', data, {});
  }

  // super_user_apis
  clearTrash(): Observable<any> {
    return this._api.delete('general/delete-all', {});
  }
  clearRedis(): Observable<any> {
    return this._api.delete('general/cache/flush', {});
  }

  // mini games
  getMiniGame(data): Observable<any> {
    return this._api.get('mini-games/list', data, {});
  }
  editMiniGame(data): Observable<any> {
    return this._api.put('mini-games/edit', data, {});
  }
  deleteMiniGame(data): Observable<any> {
    return this._api.delete('mini-games', { body: data });
  }
  addMiniGame(data): Observable<any> {
    return this._api.post('mini-games/add', data, {});
  }

  // password games
  getPasswordGame(data): Observable<any> {
    return this._api.get('password-game/list', data, {});
  }
  editPasswordGame(data): Observable<any> {
    return this._api.put('password-game/edit', data, {});
  }
  deletePasswordGame(data): Observable<any> {
    return this._api.delete('password-game', { body: data });
  }
  addPasswordGame(data): Observable<any> {
    return this._api.post('password-game/add', data, {});
  }

  // values game
  getValuesGameList(query): Observable<IListData> {
    return this._api.get('values-game/list', query, {});
  }

  getValuesGameReport(valuesGameId: string): Observable<any> {
    return this._api.get(
      'values-game-player/usageReport',
      { valuesGameId },
      {
        responseType: 'blob',
      },
    );
  }

  addValuesGame(data): Observable<any> {
    return this._api.post('values-game/', data, {});
  }

  getValuesGameById(data): Observable<any> {
    return this._api.get('values-game/' + data, {}, {});
  }

  editValuesGame(data): Observable<any> {
    return this._api.put('values-game/', data, {});
  }

  deleteValuesGame(data): Observable<any> {
    return this._api.delete('values-game', { body: data });
  }

  // feedback Questions

  getFeedbackQuestionSetsList(query): Observable<IListData> {
    return this._api.get('feedback/question-sets/list', query, {});
  }
  addFeedbackQuestionSets(data): Observable<any> {
    return this._api.post('feedback/question-sets/add', data, {});
  }
  editFeedbackQuestionSets(data): Observable<any> {
    return this._api.put('feedback/question-sets/edit', data, {});
  }
  deleteFeedbackQuestionSets(data): Observable<any> {
    return this._api.delete('feedback/question-sets', { body: data });
  }

  // feedback surveys

  getFeedbackSurveyList(data): Observable<IListData> {
    return this._api.post('feedback/surveys/listfeedbacksurveys', data, {});
  }

  getFeedbackSummaryList(data): Observable<[]> {
    return this._api.post('feedback/surveys/getfeedbacksummary', data, {});
  }

  // aptitude scores
  getAptitudeScoreList(email = null): Observable<TAptitudeListResponse> {
    const qp = email ? { search: email } : {};

    if (email) {
      qp['email'] = email;
    }

    // if (limit) {
    //   qp['limit'] = limit;
    // }

    // if (skip) {
    //   qp['skip'] = skip;
    // }

    return this._api.get('aptitude/invites/list', qp, {});
  }
  getAssessmentById(assessmentId): Observable<any> {
    return this._api.get('aptitude/assessments/' + assessmentId, {}, {});
  }
  processAptiScore(data: {
    email: string;
    assessmentId: string;
  }): Observable<any> {
    return this._api.post('aptitude/invites/process-score', data, {});
  }
  downloadAptitudeReport(data: { assessmentId: string }): Observable<any> {
    return this._api.post('aptitude/invites/download-report', data, {
      responseType: 'blob',
    });
  }
  deleteAptiCandidateInvite(data: {
    email: string;
    assessmentId: string;
  }): Observable<any> {
    return this._api.delete('aptitude/invites/', { body: data });
  }

  downloadAssessmentGameReport(data: {
    gameId: string;
    gameName: string;
  }): Observable<any> {
    return this._api.post('aptitude/invites/download-game-report', data, {
      responseType: 'blob',
    });
  }

  //Polly
  listVoices(): Observable<TPollyVoice[]> {
    return this._api.get('polly/listvoices').pipe(map((data) => data.Voices));
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  getSpeechFromText(data: { Text: string; VoiceId: string }): Observable<any> {
    return this._api.post('polly/getspeech', data, {
      responseType: 'audio/mpeg',
    });
  }

  uploadPolyExcelFile(fileFormData): Observable<any> {
    return this._api.post('polly/getdialogue', fileFormData);
  }

  // mario game

  getMarioGameList(query): Observable<any> {
    return this._api.get('mario-game/list', query);
  }

  getMarioGameById(id): Observable<any> {
    return this._api.get('mario-game/' + id);
  }

  addMarioGame(marioGameData: MarioGameType): Observable<any> {
    return this._api.post('mario-game', marioGameData);
  }
  deleteMarioGame(gameInfo: { _id: string; name: string }): Observable<any> {
    return this._api.delete('mario-game', { body: gameInfo });
  }
  editMarioGame(gameData: MarioGameType): Observable<any> {
    return this._api.put('mario-game', gameData);
  }

  // packing game
  getPackingGameList(query): Observable<any> {
    return this._api.get('packing-game/list', query);
  }

  getPackingGameById(id): Observable<any> {
    return this._api.get('packing-game/' + id);
  }

  addPackingGame(packingGameData: PackingGameType): Observable<any> {
    return this._api.post('packing-game', packingGameData);
  }

  deletePackingGame(gameInfo: { _id: string; name: string }): Observable<any> {
    return this._api.delete('packing-game', { body: gameInfo });
  }

  editPackingGame(packingGameData: PackingGameType): Observable<any> {
    return this._api.put('packing-game', packingGameData);
  }

  hintsImage(data: any): Observable<any> {
    return this._api.put('hint-image', data);
  }

  downloadAllCandidateReport(): Observable<any> {
    return this._api.get(
      'aptitude/invites/download-all-candidates',
      {},
      {
        responseType: 'blob',
      },
    );
  }

  // file L1 element
  generatedSignedURL(data: any): Observable<any> {
    return this._api.post('file/signedurl', data);
  }

  getFile(data): Observable<IListData> {
    return this._api.get('file', data, {});
  }
  editFile(data): Observable<any> {
    return this._api.put('file', data, {});
  }
  deleteFile(data): Observable<any> {
    return this._api.delete('file', { body: data });
  }

  addFile(data): Observable<any> {
    return this._api.post('file', data, {});
  }

  uploadfileAWSS3(
    fileuploadurl,
    contenttype,
    file,
    contentDisposition,
  ): Observable<any> {
    return this._api.uploadfileAWSS3(
      fileuploadurl,
      contenttype,
      file,
      contentDisposition,
    );
  }

  // lemonade tycoon
  addLemonadePlayer(data): Observable<any> {
    return this._api.post('lemonade-tycoon/player', data, {});
  }

  editLemonadePlayer(data): Observable<any> {
    return this._api.put('lemonade-tycoon/player', data, {});
  }

  getLemonadePlayersList(query): Observable<any> {
    return this._api.get('lemonade-tycoon/players', query, {});
  }

  deleteLemonadePlayer(data): Observable<any> {
    return this._api.delete('lemonade-tycoon/player', { body: data });
  }

  addLemonadeCohort(data): Observable<any> {
    return this._api.post('lemonade-tycoon/cohort', data, {});
  }

  getLemonadeCohort(query): Observable<any> {
    return this._api.get('lemonade-tycoon/cohorts', query, {});
  }
  deleteLemonadeCohort(_id): Observable<any> {
    return this._api.delete('lemonade-tycoon/cohort', { body: _id });
  }
  updateLemonadeCohort(data): Observable<any> {
    return this._api.put('lemonade-tycoon/cohort', data, {});
  }

  getLemonadeCohortById(id): Observable<any> {
    return this._api.get('lemonade-tycoon/cohort/' + id);
  }

  addPlayerToCohortLemonade(data): Observable<any> {
    return this._api.post('lemonade-tycoon/cohort/add', data, {});
  }

  removePlayerFromCohortLemonade(data): Observable<any> {
    return this._api.post('lemonade-tycoon/cohort/remove', data, {});
  }

  addPlayerExcelLemonade(divisionId, file): Observable<any> {
    return this._api.post('lemonade-tycoon/players/' + divisionId, file);
  }
  addPlayerExcelCohortLemonade(cohortId, file): Observable<any> {
    return this._api.post(
      'lemonade-tycoon/cohort/' + cohortId + '/players',
      file,
    );
  }

  updateCohortStatus({ cohort, status }): Observable<any> {
    return this._api.post('lemonade-tycoon/cohort/status', { cohort, status });
  }

  // add Wheel game
  addMonopolyGame(data: any): Observable<ArrayBuffer> {
    return this._api.post('monopoly-turn-game', data, {});
  }
  getMonopolyGames(query): Observable<IListData> {
    return this._api.get('monopoly-turn-game', query, {});
  }
  getMonopolyGameById(id): Observable<IListData> {
    return this._api.get('monopoly-turn-game/' + id, {});
  }
  editMonopolyGame(data): Observable<ArrayBuffer> {
    return this._api.put('monopoly-turn-game', data);
  }

  deleteMonopolyGame(_id): Observable<ArrayBuffer> {
    return this._api.delete('monopoly-turn-game', { body: _id });
  }
}

export interface PackingGameType {
  name: string;
  timer: number;
  points: number;
  penalty: number;
  introSequence: string;
  tutorial: boolean;
  classification: string;
  categories: number;
}

export interface MarioGameType {
  name: string;
  timer: number;
  points: number;
  penalty: number;
  introSequence: string;
  questions: string[];
  tutorial: boolean;
}

export interface IListData {
  list: object[];
  totalCount: number;
}

export interface IListParams {
  skip?: number;
  limit?: number;
  search?: string;
  ipadimagesonly?: boolean;
}

export interface ICompanyListData {
  _id?: any;
  sections?: any;
  name?: string;
}

export interface IlazyPaths {
  name: string;
  path: string;
  data?: BehaviorSubject<any>;
  isLoading?: boolean;
}

export interface IplayerRouteDetails {
  companyId: any;
  divisionId: any;
  page: number;
  search?: any;
}

export interface TAptitudeGameListResponse {
  list: {
    createdAt: string;
    gameType: string;
    name: string;
    _id: string;
  }[];
  totalCount: 1;
}

export interface TAptitudeListResponse {
  list: [
    {
      _id: string;
      name: string;
      email: string;
      companyId: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Proctoring: boolean;
        _id: string;
        name: string;
      };
      assessmentId: string;
      processedScoreAvg: {
        _id: string;
        score: number;
        gameName: string;
      }[];
    },
  ];
  totalCount: number;
}

export interface TAptiCandidate {
  _id: string;
  gameStatus: string;
  starred: string;
  email: string;
  name: string;
  assessmentId: string;
  aptitudeScores: any[];
  processedScores: any[];
  processedScoreAvg: any[];
}
